import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from "graphql";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & {
  [P in K]-?: NonNullable<T[P]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
};

export type CoordinatePosition = {
  __typename?: "CoordinatePosition";
  x: Scalars["Float"]["output"];
  y: Scalars["Float"]["output"];
};

export type CoordinatePositionInput = {
  x: Scalars["Float"]["input"];
  y: Scalars["Float"]["input"];
};

export type Event = {
  __typename?: "Event";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  device?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  layout?: Maybe<Scalars["ID"]["output"]>;
  location?: Maybe<Scalars["ID"]["output"]>;
  organization: Scalars["String"]["output"];
  payload?: Maybe<Array<EventPayload>>;
  post?: Maybe<Scalars["ID"]["output"]>;
  profile?: Maybe<Scalars["ID"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventFilter = {
  device?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  eventType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  layouts?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  location?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  post?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  profile?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  range?: InputMaybe<EventFilterDateRange>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EventFilterDateRange = {
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type EventInput = {
  device?: InputMaybe<Scalars["ID"]["input"]>;
  layout?: InputMaybe<Scalars["ID"]["input"]>;
  location?: InputMaybe<Scalars["ID"]["input"]>;
  payloadOneOf: EventPayloadInput;
  post?: InputMaybe<Scalars["ID"]["input"]>;
  profile?: InputMaybe<Scalars["ID"]["input"]>;
  type: EventPayloadType;
};

export type EventPayload =
  | EventPayloadCacheReloadRequest
  | EventPayloadDeviceActive
  | EventPayloadDeviceStarted
  | EventPayloadPostActioned
  | EventPayloadPostClosed
  | EventPayloadPostInteracted
  | EventPayloadPostShown
  | EventPayloadPostTimeExtended
  | EventPayloadPostTimedOut
  | EventPayloadProfileLoaded
  | EventPayloadQrCode
  | EventPayloadRestingMediaInteracted
  | EventPayloadRestingMediaStarted
  | EventPayloadRestingMediaTimedOut
  | EventPayloadSearchQuery
  | EventPayloadTriviaQuestion
  | EventPayloadVideoSource;

export type EventPayloadCacheReloadRequest = {
  __typename?: "EventPayloadCacheReloadRequest";
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadCacheReloadRequestInput = {
  type?: EventPayloadType;
};

export type EventPayloadDeviceActive = {
  __typename?: "EventPayloadDeviceActive";
  initialitzation?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadDeviceActiveInput = {
  initialitzation?: InputMaybe<Scalars["String"]["input"]>;
};

export type EventPayloadDeviceStarted = {
  __typename?: "EventPayloadDeviceStarted";
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadDeviceStartedInput = {
  type?: EventPayloadType;
};

export type EventPayloadInput = {
  CACHE_RELOAD_REQUEST?: InputMaybe<EventPayloadCacheReloadRequestInput>;
  DEVICE_ACTIVE?: InputMaybe<EventPayloadDeviceActiveInput>;
  DEVICE_STARTED?: InputMaybe<EventPayloadDeviceStartedInput>;
  POST_ACTIONED?: InputMaybe<EventPayloadPostActionedInput>;
  POST_CLOSED?: InputMaybe<EventPayloadPostClosedInput>;
  POST_INTERACTED?: InputMaybe<EventPayloadPostInteractedInput>;
  POST_SHOWN?: InputMaybe<EventPayloadPostShownInput>;
  POST_TIMED_OUT?: InputMaybe<EventPayloadPostTimedOutInput>;
  POST_TIME_EXTENDED?: InputMaybe<EventPayloadPostTimeExtendedInput>;
  PROFILE_LOADED?: InputMaybe<EventPayloadProfileLoadedInput>;
  QR_CODE?: InputMaybe<EventPayloadQrCodeInput>;
  RESTING_MEDIA_INTERACTED?: InputMaybe<EventPayloadRestingMediaInteractedInput>;
  RESTING_MEDIA_STARTED?: InputMaybe<EventPayloadRestingMediaStartedInput>;
  RESTING_MEDIA_TIMED_OUT?: InputMaybe<EventPayloadRestingMediaTimedOutInput>;
  SEARCH_QUERY?: InputMaybe<EventPayloadSearchQueryInput>;
  TRIVIA_QUESTION?: InputMaybe<EventPayloadTriviaQuestionInput>;
  VIDEO_SOURCE?: InputMaybe<EventPayloadVideoSourceInput>;
};

export type EventPayloadPostActioned = {
  __typename?: "EventPayloadPostActioned";
  flyout?: Maybe<Scalars["String"]["output"]>;
  position: CoordinatePosition;
  screen: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadPostActionedInput = {
  flyout?: InputMaybe<Scalars["String"]["input"]>;
  position: CoordinatePositionInput;
  screen: Scalars["Float"]["input"];
};

export type EventPayloadPostClosed = {
  __typename?: "EventPayloadPostClosed";
  duration?: Maybe<Scalars["Float"]["output"]>;
  position: CoordinatePosition;
  screen: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadPostClosedInput = {
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  position: CoordinatePositionInput;
  screen: Scalars["Float"]["input"];
};

export type EventPayloadPostInteracted = {
  __typename?: "EventPayloadPostInteracted";
  position: CoordinatePosition;
  screen: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadPostInteractedInput = {
  position: CoordinatePositionInput;
  screen: Scalars["Float"]["input"];
};

export type EventPayloadPostShown = {
  __typename?: "EventPayloadPostShown";
  screen: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadPostShownInput = {
  screen: Scalars["Float"]["input"];
};

export type EventPayloadPostTimeExtended = {
  __typename?: "EventPayloadPostTimeExtended";
  position: CoordinatePosition;
  screen: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadPostTimeExtendedInput = {
  position: CoordinatePositionInput;
  screen: Scalars["Float"]["input"];
};

export type EventPayloadPostTimedOut = {
  __typename?: "EventPayloadPostTimedOut";
  duration?: Maybe<Scalars["Float"]["output"]>;
  screen: Scalars["Float"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadPostTimedOutInput = {
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  screen: Scalars["Float"]["input"];
};

export type EventPayloadProfileLoaded = {
  __typename?: "EventPayloadProfileLoaded";
  profile?: Maybe<Scalars["ID"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadProfileLoadedInput = {
  profile?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EventPayloadQrCode = {
  __typename?: "EventPayloadQrCode";
  link: Scalars["String"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadQrCodeInput = {
  link: Scalars["String"]["input"];
};

export type EventPayloadRestingMediaInteracted = {
  __typename?: "EventPayloadRestingMediaInteracted";
  media?: Maybe<Scalars["ID"]["output"]>;
  position: CoordinatePosition;
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadRestingMediaInteractedInput = {
  media: Scalars["ID"]["input"];
  position: CoordinatePositionInput;
};

export type EventPayloadRestingMediaStarted = {
  __typename?: "EventPayloadRestingMediaStarted";
  media?: Maybe<Scalars["ID"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadRestingMediaStartedInput = {
  media: Scalars["ID"]["input"];
};

export type EventPayloadRestingMediaTimedOut = {
  __typename?: "EventPayloadRestingMediaTimedOut";
  media?: Maybe<Scalars["ID"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadRestingMediaTimedOutInput = {
  media: Scalars["ID"]["input"];
};

export type EventPayloadSearchQuery = {
  __typename?: "EventPayloadSearchQuery";
  query?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadSearchQueryInput = {
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type EventPayloadTriviaQuestion = {
  __typename?: "EventPayloadTriviaQuestion";
  answer?: Maybe<Scalars["String"]["output"]>;
  correct?: Maybe<Scalars["Boolean"]["output"]>;
  postId?: Maybe<Scalars["String"]["output"]>;
  question?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadTriviaQuestionInput = {
  answer?: InputMaybe<Scalars["String"]["input"]>;
  correct?: InputMaybe<Scalars["Boolean"]["input"]>;
  postId?: InputMaybe<Scalars["String"]["input"]>;
  question?: InputMaybe<Scalars["String"]["input"]>;
  type?: EventPayloadType;
};

export enum EventPayloadType {
  CacheReloadRequest = "CACHE_RELOAD_REQUEST",
  DeviceActive = "DEVICE_ACTIVE",
  DeviceStarted = "DEVICE_STARTED",
  PostActioned = "POST_ACTIONED",
  PostClosed = "POST_CLOSED",
  PostInteracted = "POST_INTERACTED",
  PostShown = "POST_SHOWN",
  PostTimedOut = "POST_TIMED_OUT",
  PostTimeExtended = "POST_TIME_EXTENDED",
  ProfileLoaded = "PROFILE_LOADED",
  QrCode = "QR_CODE",
  RestingMediaInteracted = "RESTING_MEDIA_INTERACTED",
  RestingMediaStarted = "RESTING_MEDIA_STARTED",
  RestingMediaTimedOut = "RESTING_MEDIA_TIMED_OUT",
  SearchQuery = "SEARCH_QUERY",
  TriviaQuestion = "TRIVIA_QUESTION",
  VideoSource = "VIDEO_SOURCE",
}

export type EventPayloadVideoSource = {
  __typename?: "EventPayloadVideoSource";
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
  type: EventPayloadType;
};

export type EventPayloadVideoSourceInput = {
  id?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: EventPayloadType;
};

export type ListMetadata = {
  __typename?: "ListMetadata";
  count: Scalars["Float"]["output"];
};

export type Log = {
  __typename?: "Log";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  device?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  level: LogLevelType;
  message?: Maybe<Scalars["String"]["output"]>;
  organization: Scalars["String"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type LogFilter = {
  device?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  level?: InputMaybe<Array<LogLevelType>>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  range?: InputMaybe<LogFilterDateRange>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LogFilterDateRange = {
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type LogInput = {
  device?: InputMaybe<Scalars["ID"]["input"]>;
  level: LogLevelType;
  message?: InputMaybe<Scalars["String"]["input"]>;
  timestamp: Scalars["DateTime"]["input"];
};

export enum LogLevelType {
  Debug = "DEBUG",
  Error = "ERROR",
  Info = "INFO",
  Warn = "WARN",
}

export type Mutation = {
  __typename?: "Mutation";
  createEvent: Event;
  createEvents: Array<Event>;
  createLog: Log;
  createLogs: Array<Log>;
};

export type MutationCreateEventArgs = {
  event: EventInput;
};

export type MutationCreateEventsArgs = {
  events: Array<EventInput>;
};

export type MutationCreateLogArgs = {
  log: LogInput;
};

export type MutationCreateLogsArgs = {
  logs: Array<LogInput>;
};

export type Query = {
  __typename?: "Query";
  Event: Event;
  Log: Log;
  _allEventsMeta: ListMetadata;
  allEvents: Array<Event>;
  allLogs: Array<Log>;
};

export type QueryEventArgs = {
  id: Scalars["String"]["input"];
};

export type QueryLogArgs = {
  id: Scalars["String"]["input"];
};

export type Query_AllEventsMetaArgs = {
  filter?: InputMaybe<EventFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllEventsArgs = {
  filter?: InputMaybe<EventFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllLogsArgs = {
  filter?: InputMaybe<LogFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

type EventPayloadProps_EventPayloadCacheReloadRequest_Fragment = {
  __typename?: "EventPayloadCacheReloadRequest";
};

type EventPayloadProps_EventPayloadDeviceActive_Fragment = {
  __typename?: "EventPayloadDeviceActive";
  type: EventPayloadType;
  initialitzation?: string | null;
};

type EventPayloadProps_EventPayloadDeviceStarted_Fragment = {
  __typename?: "EventPayloadDeviceStarted";
};

type EventPayloadProps_EventPayloadPostActioned_Fragment = {
  __typename?: "EventPayloadPostActioned";
  type: EventPayloadType;
  screen: number;
  flyout?: string | null;
  position: { __typename?: "CoordinatePosition"; x: number; y: number };
};

type EventPayloadProps_EventPayloadPostClosed_Fragment = {
  __typename?: "EventPayloadPostClosed";
  type: EventPayloadType;
  screen: number;
  duration?: number | null;
  position: { __typename?: "CoordinatePosition"; x: number; y: number };
};

type EventPayloadProps_EventPayloadPostInteracted_Fragment = {
  __typename?: "EventPayloadPostInteracted";
  type: EventPayloadType;
  screen: number;
  position: { __typename?: "CoordinatePosition"; x: number; y: number };
};

type EventPayloadProps_EventPayloadPostShown_Fragment = {
  __typename?: "EventPayloadPostShown";
  type: EventPayloadType;
  screen: number;
};

type EventPayloadProps_EventPayloadPostTimeExtended_Fragment = {
  __typename?: "EventPayloadPostTimeExtended";
  type: EventPayloadType;
  screen: number;
  position: { __typename?: "CoordinatePosition"; x: number; y: number };
};

type EventPayloadProps_EventPayloadPostTimedOut_Fragment = {
  __typename?: "EventPayloadPostTimedOut";
  type: EventPayloadType;
  screen: number;
  duration?: number | null;
};

type EventPayloadProps_EventPayloadProfileLoaded_Fragment = {
  __typename?: "EventPayloadProfileLoaded";
  type: EventPayloadType;
};

type EventPayloadProps_EventPayloadQrCode_Fragment = {
  __typename?: "EventPayloadQrCode";
  type: EventPayloadType;
  link: string;
};

type EventPayloadProps_EventPayloadRestingMediaInteracted_Fragment = {
  __typename?: "EventPayloadRestingMediaInteracted";
  type: EventPayloadType;
  media?: string | null;
  position: { __typename?: "CoordinatePosition"; x: number; y: number };
};

type EventPayloadProps_EventPayloadRestingMediaStarted_Fragment = {
  __typename?: "EventPayloadRestingMediaStarted";
  type: EventPayloadType;
  media?: string | null;
};

type EventPayloadProps_EventPayloadRestingMediaTimedOut_Fragment = {
  __typename?: "EventPayloadRestingMediaTimedOut";
  type: EventPayloadType;
  media?: string | null;
};

type EventPayloadProps_EventPayloadSearchQuery_Fragment = {
  __typename?: "EventPayloadSearchQuery";
  type: EventPayloadType;
  query?: string | null;
};

type EventPayloadProps_EventPayloadTriviaQuestion_Fragment = {
  __typename?: "EventPayloadTriviaQuestion";
  type: EventPayloadType;
  postId?: string | null;
  question?: string | null;
  answer?: string | null;
  correct?: boolean | null;
};

type EventPayloadProps_EventPayloadVideoSource_Fragment = {
  __typename?: "EventPayloadVideoSource";
  type: EventPayloadType;
  id?: string | null;
  name?: string | null;
};

export type EventPayloadPropsFragment =
  | EventPayloadProps_EventPayloadCacheReloadRequest_Fragment
  | EventPayloadProps_EventPayloadDeviceActive_Fragment
  | EventPayloadProps_EventPayloadDeviceStarted_Fragment
  | EventPayloadProps_EventPayloadPostActioned_Fragment
  | EventPayloadProps_EventPayloadPostClosed_Fragment
  | EventPayloadProps_EventPayloadPostInteracted_Fragment
  | EventPayloadProps_EventPayloadPostShown_Fragment
  | EventPayloadProps_EventPayloadPostTimeExtended_Fragment
  | EventPayloadProps_EventPayloadPostTimedOut_Fragment
  | EventPayloadProps_EventPayloadProfileLoaded_Fragment
  | EventPayloadProps_EventPayloadQrCode_Fragment
  | EventPayloadProps_EventPayloadRestingMediaInteracted_Fragment
  | EventPayloadProps_EventPayloadRestingMediaStarted_Fragment
  | EventPayloadProps_EventPayloadRestingMediaTimedOut_Fragment
  | EventPayloadProps_EventPayloadSearchQuery_Fragment
  | EventPayloadProps_EventPayloadTriviaQuestion_Fragment
  | EventPayloadProps_EventPayloadVideoSource_Fragment;

export type GetEventQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetEventQuery = {
  __typename?: "Query";
  item: {
    __typename: "Event";
    _id?: string | null;
    _version?: number | null;
    device?: string | null;
    id?: string | null;
    layout?: string | null;
    location?: string | null;
    organization: string;
    post?: string | null;
    profile?: string | null;
    timestamp: any;
    type: EventPayloadType;
    payload?: Array<
      | { __typename?: "EventPayloadCacheReloadRequest" }
      | {
          __typename?: "EventPayloadDeviceActive";
          type: EventPayloadType;
          initialitzation?: string | null;
        }
      | { __typename?: "EventPayloadDeviceStarted" }
      | {
          __typename?: "EventPayloadPostActioned";
          type: EventPayloadType;
          screen: number;
          flyout?: string | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostClosed";
          type: EventPayloadType;
          screen: number;
          duration?: number | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostInteracted";
          type: EventPayloadType;
          screen: number;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostShown";
          type: EventPayloadType;
          screen: number;
        }
      | {
          __typename?: "EventPayloadPostTimeExtended";
          type: EventPayloadType;
          screen: number;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostTimedOut";
          type: EventPayloadType;
          screen: number;
          duration?: number | null;
        }
      | { __typename?: "EventPayloadProfileLoaded"; type: EventPayloadType }
      | {
          __typename?: "EventPayloadQrCode";
          type: EventPayloadType;
          link: string;
        }
      | {
          __typename?: "EventPayloadRestingMediaInteracted";
          type: EventPayloadType;
          media?: string | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadRestingMediaStarted";
          type: EventPayloadType;
          media?: string | null;
        }
      | {
          __typename?: "EventPayloadRestingMediaTimedOut";
          type: EventPayloadType;
          media?: string | null;
        }
      | {
          __typename?: "EventPayloadSearchQuery";
          type: EventPayloadType;
          query?: string | null;
        }
      | {
          __typename?: "EventPayloadTriviaQuestion";
          type: EventPayloadType;
          postId?: string | null;
          question?: string | null;
          answer?: string | null;
          correct?: boolean | null;
        }
      | {
          __typename?: "EventPayloadVideoSource";
          type: EventPayloadType;
          id?: string | null;
          name?: string | null;
        }
    > | null;
  };
};

export type GetEventsQueryVariables = Exact<{
  filter?: InputMaybe<EventFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetEventsQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Event";
    _id?: string | null;
    _version?: number | null;
    device?: string | null;
    id?: string | null;
    layout?: string | null;
    location?: string | null;
    organization: string;
    post?: string | null;
    profile?: string | null;
    timestamp: any;
    type: EventPayloadType;
    payload?: Array<
      | { __typename?: "EventPayloadCacheReloadRequest" }
      | {
          __typename?: "EventPayloadDeviceActive";
          type: EventPayloadType;
          initialitzation?: string | null;
        }
      | { __typename?: "EventPayloadDeviceStarted" }
      | {
          __typename?: "EventPayloadPostActioned";
          type: EventPayloadType;
          screen: number;
          flyout?: string | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostClosed";
          type: EventPayloadType;
          screen: number;
          duration?: number | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostInteracted";
          type: EventPayloadType;
          screen: number;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostShown";
          type: EventPayloadType;
          screen: number;
        }
      | {
          __typename?: "EventPayloadPostTimeExtended";
          type: EventPayloadType;
          screen: number;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostTimedOut";
          type: EventPayloadType;
          screen: number;
          duration?: number | null;
        }
      | { __typename?: "EventPayloadProfileLoaded"; type: EventPayloadType }
      | {
          __typename?: "EventPayloadQrCode";
          type: EventPayloadType;
          link: string;
        }
      | {
          __typename?: "EventPayloadRestingMediaInteracted";
          type: EventPayloadType;
          media?: string | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadRestingMediaStarted";
          type: EventPayloadType;
          media?: string | null;
        }
      | {
          __typename?: "EventPayloadRestingMediaTimedOut";
          type: EventPayloadType;
          media?: string | null;
        }
      | {
          __typename?: "EventPayloadSearchQuery";
          type: EventPayloadType;
          query?: string | null;
        }
      | {
          __typename?: "EventPayloadTriviaQuestion";
          type: EventPayloadType;
          postId?: string | null;
          question?: string | null;
          answer?: string | null;
          correct?: boolean | null;
        }
      | {
          __typename?: "EventPayloadVideoSource";
          type: EventPayloadType;
          id?: string | null;
          name?: string | null;
        }
    > | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type CreateEventMutationVariables = Exact<{
  event: EventInput;
}>;

export type CreateEventMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Event";
    _id?: string | null;
    _version?: number | null;
    device?: string | null;
    id?: string | null;
    layout?: string | null;
    location?: string | null;
    organization: string;
    post?: string | null;
    profile?: string | null;
    timestamp: any;
    type: EventPayloadType;
    payload?: Array<
      | { __typename?: "EventPayloadCacheReloadRequest" }
      | {
          __typename?: "EventPayloadDeviceActive";
          type: EventPayloadType;
          initialitzation?: string | null;
        }
      | { __typename?: "EventPayloadDeviceStarted" }
      | {
          __typename?: "EventPayloadPostActioned";
          type: EventPayloadType;
          screen: number;
          flyout?: string | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostClosed";
          type: EventPayloadType;
          screen: number;
          duration?: number | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostInteracted";
          type: EventPayloadType;
          screen: number;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostShown";
          type: EventPayloadType;
          screen: number;
        }
      | {
          __typename?: "EventPayloadPostTimeExtended";
          type: EventPayloadType;
          screen: number;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostTimedOut";
          type: EventPayloadType;
          screen: number;
          duration?: number | null;
        }
      | { __typename?: "EventPayloadProfileLoaded"; type: EventPayloadType }
      | {
          __typename?: "EventPayloadQrCode";
          type: EventPayloadType;
          link: string;
        }
      | {
          __typename?: "EventPayloadRestingMediaInteracted";
          type: EventPayloadType;
          media?: string | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadRestingMediaStarted";
          type: EventPayloadType;
          media?: string | null;
        }
      | {
          __typename?: "EventPayloadRestingMediaTimedOut";
          type: EventPayloadType;
          media?: string | null;
        }
      | {
          __typename?: "EventPayloadSearchQuery";
          type: EventPayloadType;
          query?: string | null;
        }
      | {
          __typename?: "EventPayloadTriviaQuestion";
          type: EventPayloadType;
          postId?: string | null;
          question?: string | null;
          answer?: string | null;
          correct?: boolean | null;
        }
      | {
          __typename?: "EventPayloadVideoSource";
          type: EventPayloadType;
          id?: string | null;
          name?: string | null;
        }
    > | null;
  };
};

export type CreateEventsMutationVariables = Exact<{
  events: Array<EventInput> | EventInput;
}>;

export type CreateEventsMutation = {
  __typename?: "Mutation";
  data: Array<{
    __typename: "Event";
    _id?: string | null;
    _version?: number | null;
    device?: string | null;
    id?: string | null;
    layout?: string | null;
    location?: string | null;
    organization: string;
    post?: string | null;
    profile?: string | null;
    timestamp: any;
    type: EventPayloadType;
    payload?: Array<
      | { __typename?: "EventPayloadCacheReloadRequest" }
      | {
          __typename?: "EventPayloadDeviceActive";
          type: EventPayloadType;
          initialitzation?: string | null;
        }
      | { __typename?: "EventPayloadDeviceStarted" }
      | {
          __typename?: "EventPayloadPostActioned";
          type: EventPayloadType;
          screen: number;
          flyout?: string | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostClosed";
          type: EventPayloadType;
          screen: number;
          duration?: number | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostInteracted";
          type: EventPayloadType;
          screen: number;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostShown";
          type: EventPayloadType;
          screen: number;
        }
      | {
          __typename?: "EventPayloadPostTimeExtended";
          type: EventPayloadType;
          screen: number;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadPostTimedOut";
          type: EventPayloadType;
          screen: number;
          duration?: number | null;
        }
      | { __typename?: "EventPayloadProfileLoaded"; type: EventPayloadType }
      | {
          __typename?: "EventPayloadQrCode";
          type: EventPayloadType;
          link: string;
        }
      | {
          __typename?: "EventPayloadRestingMediaInteracted";
          type: EventPayloadType;
          media?: string | null;
          position: { __typename?: "CoordinatePosition"; x: number; y: number };
        }
      | {
          __typename?: "EventPayloadRestingMediaStarted";
          type: EventPayloadType;
          media?: string | null;
        }
      | {
          __typename?: "EventPayloadRestingMediaTimedOut";
          type: EventPayloadType;
          media?: string | null;
        }
      | {
          __typename?: "EventPayloadSearchQuery";
          type: EventPayloadType;
          query?: string | null;
        }
      | {
          __typename?: "EventPayloadTriviaQuestion";
          type: EventPayloadType;
          postId?: string | null;
          question?: string | null;
          answer?: string | null;
          correct?: boolean | null;
        }
      | {
          __typename?: "EventPayloadVideoSource";
          type: EventPayloadType;
          id?: string | null;
          name?: string | null;
        }
    > | null;
  }>;
};

export type GetLogQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetLogQuery = {
  __typename?: "Query";
  item: {
    __typename: "Log";
    _id?: string | null;
    _version?: number | null;
    device?: string | null;
    id?: string | null;
    level: LogLevelType;
    message?: string | null;
    organization: string;
    timestamp: any;
  };
};

export type GetLogsQueryVariables = Exact<{
  filter?: InputMaybe<LogFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetLogsQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Log";
    _id?: string | null;
    _version?: number | null;
    device?: string | null;
    id?: string | null;
    level: LogLevelType;
    message?: string | null;
    organization: string;
    timestamp: any;
  }>;
};

export type CreateLogMutationVariables = Exact<{
  log: LogInput;
}>;

export type CreateLogMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Log";
    _id?: string | null;
    _version?: number | null;
    device?: string | null;
    id?: string | null;
    level: LogLevelType;
    message?: string | null;
    organization: string;
    timestamp: any;
  };
};

export type CreateLogsMutationVariables = Exact<{
  logs: Array<LogInput> | LogInput;
}>;

export type CreateLogsMutation = {
  __typename?: "Mutation";
  data: Array<{
    __typename: "Log";
    _id?: string | null;
    _version?: number | null;
    device?: string | null;
    id?: string | null;
    level: LogLevelType;
    message?: string | null;
    organization: string;
    timestamp: any;
  }>;
};

export const EventPayloadPropsFragmentDoc = gql`
  fragment EventPayloadProps on EventPayload {
    ... on EventPayloadPostShown {
      type
      screen
    }
    ... on EventPayloadPostActioned {
      type
      screen
      position {
        x
        y
      }
      flyout
    }
    ... on EventPayloadPostInteracted {
      type
      screen
      position {
        x
        y
      }
    }
    ... on EventPayloadPostClosed {
      type
      screen
      position {
        x
        y
      }
      duration
    }
    ... on EventPayloadPostTimedOut {
      type
      screen
      duration
    }
    ... on EventPayloadPostTimeExtended {
      type
      screen
      position {
        x
        y
      }
    }
    ... on EventPayloadDeviceActive {
      type
      initialitzation
    }
    ... on EventPayloadProfileLoaded {
      type
    }
    ... on EventPayloadRestingMediaStarted {
      type
      media
    }
    ... on EventPayloadRestingMediaTimedOut {
      type
      media
    }
    ... on EventPayloadRestingMediaInteracted {
      type
      media
      position {
        x
        y
      }
    }
    ... on EventPayloadQrCode {
      type
      link
    }
    ... on EventPayloadSearchQuery {
      type
      query
    }
    ... on EventPayloadVideoSource {
      type
      id
      name
    }
    ... on EventPayloadTriviaQuestion {
      type
      postId
      question
      answer
      correct
    }
  }
`;
export const GetEventDocument = gql`
  query GetEvent($id: String!) {
    item: Event(id: $id) {
      _id
      _version
      device
      id
      layout
      location
      organization
      payload {
        ...EventPayloadProps
      }
      post
      profile
      timestamp
      type
      __typename
    }
  }
  ${EventPayloadPropsFragmentDoc}
`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables> &
    ({ variables: GetEventQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(
    GetEventDocument,
    options,
  );
}
export function useGetEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventQuery,
    GetEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(
    GetEventDocument,
    options,
  );
}
export function useGetEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventQuery, GetEventQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventQuery, GetEventQueryVariables>(
    GetEventDocument,
    options,
  );
}
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<
  typeof useGetEventLazyQuery
>;
export type GetEventSuspenseQueryHookResult = ReturnType<
  typeof useGetEventSuspenseQuery
>;
export type GetEventQueryResult = Apollo.QueryResult<
  GetEventQuery,
  GetEventQueryVariables
>;
export const GetEventsDocument = gql`
  query GetEvents(
    $filter: EventFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allEvents(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      device
      id
      layout
      location
      organization
      payload {
        ...EventPayloadProps
      }
      post
      profile
      timestamp
      type
      __typename
    }
    total: _allEventsMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
  ${EventPayloadPropsFragmentDoc}
`;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEventsQuery,
    GetEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventsQuery, GetEventsQueryVariables>(
    GetEventsDocument,
    options,
  );
}
export function useGetEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventsQuery,
    GetEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(
    GetEventsDocument,
    options,
  );
}
export function useGetEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventsQuery, GetEventsQueryVariables>(
    GetEventsDocument,
    options,
  );
}
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<
  typeof useGetEventsLazyQuery
>;
export type GetEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetEventsSuspenseQuery
>;
export type GetEventsQueryResult = Apollo.QueryResult<
  GetEventsQuery,
  GetEventsQueryVariables
>;
export const CreateEventDocument = gql`
  mutation CreateEvent($event: EventInput!) {
    data: createEvent(event: $event) {
      _id
      _version
      device
      id
      layout
      location
      organization
      payload {
        ...EventPayloadProps
      }
      post
      profile
      timestamp
      type
      __typename
    }
  }
  ${EventPayloadPropsFragmentDoc}
`;
export type CreateEventMutationFn = Apollo.MutationFunction<
  CreateEventMutation,
  CreateEventMutationVariables
>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useCreateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEventMutation,
    CreateEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(
    CreateEventDocument,
    options,
  );
}
export type CreateEventMutationHookResult = ReturnType<
  typeof useCreateEventMutation
>;
export type CreateEventMutationResult =
  Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<
  CreateEventMutation,
  CreateEventMutationVariables
>;
export const CreateEventsDocument = gql`
  mutation CreateEvents($events: [EventInput!]!) {
    data: createEvents(events: $events) {
      _id
      _version
      device
      id
      layout
      location
      organization
      payload {
        ...EventPayloadProps
      }
      post
      profile
      timestamp
      type
      __typename
    }
  }
  ${EventPayloadPropsFragmentDoc}
`;
export type CreateEventsMutationFn = Apollo.MutationFunction<
  CreateEventsMutation,
  CreateEventsMutationVariables
>;

/**
 * __useCreateEventsMutation__
 *
 * To run a mutation, you first call `useCreateEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventsMutation, { data, loading, error }] = useCreateEventsMutation({
 *   variables: {
 *      events: // value for 'events'
 *   },
 * });
 */
export function useCreateEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEventsMutation,
    CreateEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEventsMutation,
    CreateEventsMutationVariables
  >(CreateEventsDocument, options);
}
export type CreateEventsMutationHookResult = ReturnType<
  typeof useCreateEventsMutation
>;
export type CreateEventsMutationResult =
  Apollo.MutationResult<CreateEventsMutation>;
export type CreateEventsMutationOptions = Apollo.BaseMutationOptions<
  CreateEventsMutation,
  CreateEventsMutationVariables
>;
export const GetLogDocument = gql`
  query GetLog($id: String!) {
    item: Log(id: $id) {
      _id
      _version
      device
      id
      level
      message
      organization
      timestamp
      __typename
    }
  }
`;

/**
 * __useGetLogQuery__
 *
 * To run a query within a React component, call `useGetLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLogQuery(
  baseOptions: Apollo.QueryHookOptions<GetLogQuery, GetLogQueryVariables> &
    ({ variables: GetLogQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLogQuery, GetLogQueryVariables>(
    GetLogDocument,
    options,
  );
}
export function useGetLogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLogQuery, GetLogQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLogQuery, GetLogQueryVariables>(
    GetLogDocument,
    options,
  );
}
export function useGetLogSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLogQuery, GetLogQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLogQuery, GetLogQueryVariables>(
    GetLogDocument,
    options,
  );
}
export type GetLogQueryHookResult = ReturnType<typeof useGetLogQuery>;
export type GetLogLazyQueryHookResult = ReturnType<typeof useGetLogLazyQuery>;
export type GetLogSuspenseQueryHookResult = ReturnType<
  typeof useGetLogSuspenseQuery
>;
export type GetLogQueryResult = Apollo.QueryResult<
  GetLogQuery,
  GetLogQueryVariables
>;
export const GetLogsDocument = gql`
  query GetLogs(
    $filter: LogFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allLogs(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      device
      id
      level
      message
      organization
      timestamp
      __typename
    }
  }
`;

/**
 * __useGetLogsQuery__
 *
 * To run a query within a React component, call `useGetLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetLogsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLogsQuery, GetLogsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLogsQuery, GetLogsQueryVariables>(
    GetLogsDocument,
    options,
  );
}
export function useGetLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLogsQuery,
    GetLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLogsQuery, GetLogsQueryVariables>(
    GetLogsDocument,
    options,
  );
}
export function useGetLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLogsQuery, GetLogsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLogsQuery, GetLogsQueryVariables>(
    GetLogsDocument,
    options,
  );
}
export type GetLogsQueryHookResult = ReturnType<typeof useGetLogsQuery>;
export type GetLogsLazyQueryHookResult = ReturnType<typeof useGetLogsLazyQuery>;
export type GetLogsSuspenseQueryHookResult = ReturnType<
  typeof useGetLogsSuspenseQuery
>;
export type GetLogsQueryResult = Apollo.QueryResult<
  GetLogsQuery,
  GetLogsQueryVariables
>;
export const CreateLogDocument = gql`
  mutation CreateLog($log: LogInput!) {
    data: createLog(log: $log) {
      _id
      _version
      device
      id
      level
      message
      organization
      timestamp
      __typename
    }
  }
`;
export type CreateLogMutationFn = Apollo.MutationFunction<
  CreateLogMutation,
  CreateLogMutationVariables
>;

/**
 * __useCreateLogMutation__
 *
 * To run a mutation, you first call `useCreateLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLogMutation, { data, loading, error }] = useCreateLogMutation({
 *   variables: {
 *      log: // value for 'log'
 *   },
 * });
 */
export function useCreateLogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLogMutation,
    CreateLogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateLogMutation, CreateLogMutationVariables>(
    CreateLogDocument,
    options,
  );
}
export type CreateLogMutationHookResult = ReturnType<
  typeof useCreateLogMutation
>;
export type CreateLogMutationResult = Apollo.MutationResult<CreateLogMutation>;
export type CreateLogMutationOptions = Apollo.BaseMutationOptions<
  CreateLogMutation,
  CreateLogMutationVariables
>;
export const CreateLogsDocument = gql`
  mutation CreateLogs($logs: [LogInput!]!) {
    data: createLogs(logs: $logs) {
      _id
      _version
      device
      id
      level
      message
      organization
      timestamp
      __typename
    }
  }
`;
export type CreateLogsMutationFn = Apollo.MutationFunction<
  CreateLogsMutation,
  CreateLogsMutationVariables
>;

/**
 * __useCreateLogsMutation__
 *
 * To run a mutation, you first call `useCreateLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLogsMutation, { data, loading, error }] = useCreateLogsMutation({
 *   variables: {
 *      logs: // value for 'logs'
 *   },
 * });
 */
export function useCreateLogsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLogsMutation,
    CreateLogsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateLogsMutation, CreateLogsMutationVariables>(
    CreateLogsDocument,
    options,
  );
}
export type CreateLogsMutationHookResult = ReturnType<
  typeof useCreateLogsMutation
>;
export type CreateLogsMutationResult =
  Apollo.MutationResult<CreateLogsMutation>;
export type CreateLogsMutationOptions = Apollo.BaseMutationOptions<
  CreateLogsMutation,
  CreateLogsMutationVariables
>;

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {},
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = {},
  TParent = {},
  TContext = {},
  TArgs = {},
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  EventPayload:
    | EventPayloadCacheReloadRequest
    | EventPayloadDeviceActive
    | EventPayloadDeviceStarted
    | EventPayloadPostActioned
    | EventPayloadPostClosed
    | EventPayloadPostInteracted
    | EventPayloadPostShown
    | EventPayloadPostTimeExtended
    | EventPayloadPostTimedOut
    | EventPayloadProfileLoaded
    | EventPayloadQrCode
    | EventPayloadRestingMediaInteracted
    | EventPayloadRestingMediaStarted
    | EventPayloadRestingMediaTimedOut
    | EventPayloadSearchQuery
    | EventPayloadTriviaQuestion
    | EventPayloadVideoSource;
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Boolean: ResolverTypeWrapper<Scalars["Boolean"]["output"]>;
  CoordinatePosition: ResolverTypeWrapper<CoordinatePosition>;
  CoordinatePositionInput: CoordinatePositionInput;
  DateTime: ResolverTypeWrapper<Scalars["DateTime"]["output"]>;
  Event: ResolverTypeWrapper<
    Omit<Event, "payload"> & {
      payload?: Maybe<Array<ResolversTypes["EventPayload"]>>;
    }
  >;
  EventFilter: EventFilter;
  EventFilterDateRange: EventFilterDateRange;
  EventInput: EventInput;
  EventPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["EventPayload"]
  >;
  EventPayloadCacheReloadRequest: ResolverTypeWrapper<EventPayloadCacheReloadRequest>;
  EventPayloadCacheReloadRequestInput: EventPayloadCacheReloadRequestInput;
  EventPayloadDeviceActive: ResolverTypeWrapper<EventPayloadDeviceActive>;
  EventPayloadDeviceActiveInput: EventPayloadDeviceActiveInput;
  EventPayloadDeviceStarted: ResolverTypeWrapper<EventPayloadDeviceStarted>;
  EventPayloadDeviceStartedInput: EventPayloadDeviceStartedInput;
  EventPayloadInput: EventPayloadInput;
  EventPayloadPostActioned: ResolverTypeWrapper<EventPayloadPostActioned>;
  EventPayloadPostActionedInput: EventPayloadPostActionedInput;
  EventPayloadPostClosed: ResolverTypeWrapper<EventPayloadPostClosed>;
  EventPayloadPostClosedInput: EventPayloadPostClosedInput;
  EventPayloadPostInteracted: ResolverTypeWrapper<EventPayloadPostInteracted>;
  EventPayloadPostInteractedInput: EventPayloadPostInteractedInput;
  EventPayloadPostShown: ResolverTypeWrapper<EventPayloadPostShown>;
  EventPayloadPostShownInput: EventPayloadPostShownInput;
  EventPayloadPostTimeExtended: ResolverTypeWrapper<EventPayloadPostTimeExtended>;
  EventPayloadPostTimeExtendedInput: EventPayloadPostTimeExtendedInput;
  EventPayloadPostTimedOut: ResolverTypeWrapper<EventPayloadPostTimedOut>;
  EventPayloadPostTimedOutInput: EventPayloadPostTimedOutInput;
  EventPayloadProfileLoaded: ResolverTypeWrapper<EventPayloadProfileLoaded>;
  EventPayloadProfileLoadedInput: EventPayloadProfileLoadedInput;
  EventPayloadQrCode: ResolverTypeWrapper<EventPayloadQrCode>;
  EventPayloadQrCodeInput: EventPayloadQrCodeInput;
  EventPayloadRestingMediaInteracted: ResolverTypeWrapper<EventPayloadRestingMediaInteracted>;
  EventPayloadRestingMediaInteractedInput: EventPayloadRestingMediaInteractedInput;
  EventPayloadRestingMediaStarted: ResolverTypeWrapper<EventPayloadRestingMediaStarted>;
  EventPayloadRestingMediaStartedInput: EventPayloadRestingMediaStartedInput;
  EventPayloadRestingMediaTimedOut: ResolverTypeWrapper<EventPayloadRestingMediaTimedOut>;
  EventPayloadRestingMediaTimedOutInput: EventPayloadRestingMediaTimedOutInput;
  EventPayloadSearchQuery: ResolverTypeWrapper<EventPayloadSearchQuery>;
  EventPayloadSearchQueryInput: EventPayloadSearchQueryInput;
  EventPayloadTriviaQuestion: ResolverTypeWrapper<EventPayloadTriviaQuestion>;
  EventPayloadTriviaQuestionInput: EventPayloadTriviaQuestionInput;
  EventPayloadType: EventPayloadType;
  EventPayloadVideoSource: ResolverTypeWrapper<EventPayloadVideoSource>;
  EventPayloadVideoSourceInput: EventPayloadVideoSourceInput;
  Float: ResolverTypeWrapper<Scalars["Float"]["output"]>;
  ID: ResolverTypeWrapper<Scalars["ID"]["output"]>;
  Int: ResolverTypeWrapper<Scalars["Int"]["output"]>;
  ListMetadata: ResolverTypeWrapper<ListMetadata>;
  Log: ResolverTypeWrapper<Log>;
  LogFilter: LogFilter;
  LogFilterDateRange: LogFilterDateRange;
  LogInput: LogInput;
  LogLevelType: LogLevelType;
  Mutation: ResolverTypeWrapper<{}>;
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars["String"]["output"]>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Boolean: Scalars["Boolean"]["output"];
  CoordinatePosition: CoordinatePosition;
  CoordinatePositionInput: CoordinatePositionInput;
  DateTime: Scalars["DateTime"]["output"];
  Event: Omit<Event, "payload"> & {
    payload?: Maybe<Array<ResolversParentTypes["EventPayload"]>>;
  };
  EventFilter: EventFilter;
  EventFilterDateRange: EventFilterDateRange;
  EventInput: EventInput;
  EventPayload: ResolversUnionTypes<ResolversParentTypes>["EventPayload"];
  EventPayloadCacheReloadRequest: EventPayloadCacheReloadRequest;
  EventPayloadCacheReloadRequestInput: EventPayloadCacheReloadRequestInput;
  EventPayloadDeviceActive: EventPayloadDeviceActive;
  EventPayloadDeviceActiveInput: EventPayloadDeviceActiveInput;
  EventPayloadDeviceStarted: EventPayloadDeviceStarted;
  EventPayloadDeviceStartedInput: EventPayloadDeviceStartedInput;
  EventPayloadInput: EventPayloadInput;
  EventPayloadPostActioned: EventPayloadPostActioned;
  EventPayloadPostActionedInput: EventPayloadPostActionedInput;
  EventPayloadPostClosed: EventPayloadPostClosed;
  EventPayloadPostClosedInput: EventPayloadPostClosedInput;
  EventPayloadPostInteracted: EventPayloadPostInteracted;
  EventPayloadPostInteractedInput: EventPayloadPostInteractedInput;
  EventPayloadPostShown: EventPayloadPostShown;
  EventPayloadPostShownInput: EventPayloadPostShownInput;
  EventPayloadPostTimeExtended: EventPayloadPostTimeExtended;
  EventPayloadPostTimeExtendedInput: EventPayloadPostTimeExtendedInput;
  EventPayloadPostTimedOut: EventPayloadPostTimedOut;
  EventPayloadPostTimedOutInput: EventPayloadPostTimedOutInput;
  EventPayloadProfileLoaded: EventPayloadProfileLoaded;
  EventPayloadProfileLoadedInput: EventPayloadProfileLoadedInput;
  EventPayloadQrCode: EventPayloadQrCode;
  EventPayloadQrCodeInput: EventPayloadQrCodeInput;
  EventPayloadRestingMediaInteracted: EventPayloadRestingMediaInteracted;
  EventPayloadRestingMediaInteractedInput: EventPayloadRestingMediaInteractedInput;
  EventPayloadRestingMediaStarted: EventPayloadRestingMediaStarted;
  EventPayloadRestingMediaStartedInput: EventPayloadRestingMediaStartedInput;
  EventPayloadRestingMediaTimedOut: EventPayloadRestingMediaTimedOut;
  EventPayloadRestingMediaTimedOutInput: EventPayloadRestingMediaTimedOutInput;
  EventPayloadSearchQuery: EventPayloadSearchQuery;
  EventPayloadSearchQueryInput: EventPayloadSearchQueryInput;
  EventPayloadTriviaQuestion: EventPayloadTriviaQuestion;
  EventPayloadTriviaQuestionInput: EventPayloadTriviaQuestionInput;
  EventPayloadVideoSource: EventPayloadVideoSource;
  EventPayloadVideoSourceInput: EventPayloadVideoSourceInput;
  Float: Scalars["Float"]["output"];
  ID: Scalars["ID"]["output"];
  Int: Scalars["Int"]["output"];
  ListMetadata: ListMetadata;
  Log: Log;
  LogFilter: LogFilter;
  LogFilterDateRange: LogFilterDateRange;
  LogInput: LogInput;
  Mutation: {};
  Query: {};
  String: Scalars["String"]["output"];
};

export type CoordinatePositionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CoordinatePosition"] = ResolversParentTypes["CoordinatePosition"],
> = {
  x?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  y?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["DateTime"], any> {
  name: "DateTime";
}

export type EventResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Event"] = ResolversParentTypes["Event"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  layout?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  payload?: Resolver<
    Maybe<Array<ResolversTypes["EventPayload"]>>,
    ParentType,
    ContextType
  >;
  post?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayload"] = ResolversParentTypes["EventPayload"],
> = {
  __resolveType: TypeResolveFn<
    | "EventPayloadCacheReloadRequest"
    | "EventPayloadDeviceActive"
    | "EventPayloadDeviceStarted"
    | "EventPayloadPostActioned"
    | "EventPayloadPostClosed"
    | "EventPayloadPostInteracted"
    | "EventPayloadPostShown"
    | "EventPayloadPostTimeExtended"
    | "EventPayloadPostTimedOut"
    | "EventPayloadProfileLoaded"
    | "EventPayloadQrCode"
    | "EventPayloadRestingMediaInteracted"
    | "EventPayloadRestingMediaStarted"
    | "EventPayloadRestingMediaTimedOut"
    | "EventPayloadSearchQuery"
    | "EventPayloadTriviaQuestion"
    | "EventPayloadVideoSource",
    ParentType,
    ContextType
  >;
};

export type EventPayloadCacheReloadRequestResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadCacheReloadRequest"] = ResolversParentTypes["EventPayloadCacheReloadRequest"],
> = {
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadDeviceActiveResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadDeviceActive"] = ResolversParentTypes["EventPayloadDeviceActive"],
> = {
  initialitzation?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadDeviceStartedResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadDeviceStarted"] = ResolversParentTypes["EventPayloadDeviceStarted"],
> = {
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadPostActionedResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadPostActioned"] = ResolversParentTypes["EventPayloadPostActioned"],
> = {
  flyout?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  position?: Resolver<
    ResolversTypes["CoordinatePosition"],
    ParentType,
    ContextType
  >;
  screen?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadPostClosedResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadPostClosed"] = ResolversParentTypes["EventPayloadPostClosed"],
> = {
  duration?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  position?: Resolver<
    ResolversTypes["CoordinatePosition"],
    ParentType,
    ContextType
  >;
  screen?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadPostInteractedResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadPostInteracted"] = ResolversParentTypes["EventPayloadPostInteracted"],
> = {
  position?: Resolver<
    ResolversTypes["CoordinatePosition"],
    ParentType,
    ContextType
  >;
  screen?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadPostShownResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadPostShown"] = ResolversParentTypes["EventPayloadPostShown"],
> = {
  screen?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadPostTimeExtendedResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadPostTimeExtended"] = ResolversParentTypes["EventPayloadPostTimeExtended"],
> = {
  position?: Resolver<
    ResolversTypes["CoordinatePosition"],
    ParentType,
    ContextType
  >;
  screen?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadPostTimedOutResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadPostTimedOut"] = ResolversParentTypes["EventPayloadPostTimedOut"],
> = {
  duration?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  screen?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadProfileLoadedResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadProfileLoaded"] = ResolversParentTypes["EventPayloadProfileLoaded"],
> = {
  profile?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadQrCodeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadQrCode"] = ResolversParentTypes["EventPayloadQrCode"],
> = {
  link?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadRestingMediaInteractedResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadRestingMediaInteracted"] = ResolversParentTypes["EventPayloadRestingMediaInteracted"],
> = {
  media?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  position?: Resolver<
    ResolversTypes["CoordinatePosition"],
    ParentType,
    ContextType
  >;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadRestingMediaStartedResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadRestingMediaStarted"] = ResolversParentTypes["EventPayloadRestingMediaStarted"],
> = {
  media?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadRestingMediaTimedOutResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadRestingMediaTimedOut"] = ResolversParentTypes["EventPayloadRestingMediaTimedOut"],
> = {
  media?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadSearchQueryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadSearchQuery"] = ResolversParentTypes["EventPayloadSearchQuery"],
> = {
  query?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadTriviaQuestionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadTriviaQuestion"] = ResolversParentTypes["EventPayloadTriviaQuestion"],
> = {
  answer?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  correct?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  postId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  question?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPayloadVideoSourceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EventPayloadVideoSource"] = ResolversParentTypes["EventPayloadVideoSource"],
> = {
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["EventPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListMetadataResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ListMetadata"] = ResolversParentTypes["ListMetadata"],
> = {
  count?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Log"] = ResolversParentTypes["Log"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  level?: Resolver<ResolversTypes["LogLevelType"], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Mutation"] = ResolversParentTypes["Mutation"],
> = {
  createEvent?: Resolver<
    ResolversTypes["Event"],
    ParentType,
    ContextType,
    RequireFields<MutationCreateEventArgs, "event">
  >;
  createEvents?: Resolver<
    Array<ResolversTypes["Event"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateEventsArgs, "events">
  >;
  createLog?: Resolver<
    ResolversTypes["Log"],
    ParentType,
    ContextType,
    RequireFields<MutationCreateLogArgs, "log">
  >;
  createLogs?: Resolver<
    Array<ResolversTypes["Log"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateLogsArgs, "logs">
  >;
};

export type QueryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Query"] = ResolversParentTypes["Query"],
> = {
  Event?: Resolver<
    ResolversTypes["Event"],
    ParentType,
    ContextType,
    RequireFields<QueryEventArgs, "id">
  >;
  Log?: Resolver<
    ResolversTypes["Log"],
    ParentType,
    ContextType,
    RequireFields<QueryLogArgs, "id">
  >;
  _allEventsMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllEventsMetaArgs, "page" | "perPage">
  >;
  allEvents?: Resolver<
    Array<ResolversTypes["Event"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllEventsArgs, "page" | "perPage">
  >;
  allLogs?: Resolver<
    Array<ResolversTypes["Log"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllLogsArgs, "page" | "perPage">
  >;
};

export type Resolvers<ContextType = any> = {
  CoordinatePosition?: CoordinatePositionResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  Event?: EventResolvers<ContextType>;
  EventPayload?: EventPayloadResolvers<ContextType>;
  EventPayloadCacheReloadRequest?: EventPayloadCacheReloadRequestResolvers<ContextType>;
  EventPayloadDeviceActive?: EventPayloadDeviceActiveResolvers<ContextType>;
  EventPayloadDeviceStarted?: EventPayloadDeviceStartedResolvers<ContextType>;
  EventPayloadPostActioned?: EventPayloadPostActionedResolvers<ContextType>;
  EventPayloadPostClosed?: EventPayloadPostClosedResolvers<ContextType>;
  EventPayloadPostInteracted?: EventPayloadPostInteractedResolvers<ContextType>;
  EventPayloadPostShown?: EventPayloadPostShownResolvers<ContextType>;
  EventPayloadPostTimeExtended?: EventPayloadPostTimeExtendedResolvers<ContextType>;
  EventPayloadPostTimedOut?: EventPayloadPostTimedOutResolvers<ContextType>;
  EventPayloadProfileLoaded?: EventPayloadProfileLoadedResolvers<ContextType>;
  EventPayloadQrCode?: EventPayloadQrCodeResolvers<ContextType>;
  EventPayloadRestingMediaInteracted?: EventPayloadRestingMediaInteractedResolvers<ContextType>;
  EventPayloadRestingMediaStarted?: EventPayloadRestingMediaStartedResolvers<ContextType>;
  EventPayloadRestingMediaTimedOut?: EventPayloadRestingMediaTimedOutResolvers<ContextType>;
  EventPayloadSearchQuery?: EventPayloadSearchQueryResolvers<ContextType>;
  EventPayloadTriviaQuestion?: EventPayloadTriviaQuestionResolvers<ContextType>;
  EventPayloadVideoSource?: EventPayloadVideoSourceResolvers<ContextType>;
  ListMetadata?: ListMetadataResolvers<ContextType>;
  Log?: LogResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
};
